<template>
  <a-textarea
    v-model:value="innerValue"
    :placeholder="placeholder"
    :disabled="disabled"
    :rows="rows"
    :auto-size="autoSize"
    :maxlength="maxlength"
    :show-count="showCount"
    :allow-clear="allowClear"
    :status="status"
    class="ant-textarea-input"
    @blur="onBlur"
  />
</template>

<script lang="ts" setup>
import { computed } from "vue";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
  autoSize?: boolean | { minRows?: number; maxRows?: number };
  maxlength?: number;
  showCount?: boolean;
  allowClear?: boolean;
  status?: "" | "error" | "warning";
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  placeholder: "",
  disabled: false,
  rows: 4,
  autoSize: false,
  maxlength: undefined,
  showCount: false,
  allowClear: true,
  status: "",
});

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
  (e: "blur", event: FocusEvent): void;
  (e: "change", value: string): void;
}>();

const innerValue = computed({
  get: () => props.modelValue ?? "",
  set: (val: string) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onBlur = (e: FocusEvent) => emit("blur", e);
</script>

<!--
  Hướng dẫn sử dụng — Textarea
  Global: <h-textarea v-model="note" :rows="4" show-count :maxlength="200" />
  Import: import { TextareaInput } from '@/components/ant/input'

  Props: modelValue, placeholder, disabled, rows, autoSize, maxlength, showCount, allowClear, status
  Events: update:modelValue, change, blur
  Docs: src/components/ant/input/README.md
-->
